// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const ToastTitle = createStyle({
  flex: 1,
  minWidth: 0,
  fontWeight: 'medium',
  props: {
    size: 'md',
  },
  color: '$textLight900',
  _dark: {
    color: '$textDark50',
  },
});
